export function areInvalidElementsOnScreen(boardContainer) {
    let children = boardContainer.children
    let quantities = {
        rocket: 0,
        ast: 0
    }
    children.forEach(el => {
        if (el.name === 'rocket') {
            quantities.rocket++
        }
        if (el.name === 'ast') {
            quantities.ast++
        }
    });

    if (quantities.rocket !== 1) return true
    if (quantities.ast > 3) return true
    return false
}